import { Injectable } from '@angular/core';
import { Observable, from, retry, tap } from 'rxjs';
import { ObjectKind } from './objects-session';
import { DateTime } from 'luxon';

import { TimeTrackingServiceBase } from 'app/classes/time-tracking-base';


@Injectable({
  providedIn: 'root'
})
export class TimeTrackingSWService extends TimeTrackingServiceBase {
  constructor() {
    super();
    this.timeTrackingWorkerService.worker.addEventListener('message', (message: MessageEvent) => {
      const { duration, durationActive } = message.data;
      this.tick(duration, durationActive);
    });
  }

  private startSession(objectId: string, objectKind: ObjectKind, sessionId: string, date: string): Observable<any> {
    const orgId = this.organizationService.organizationSelectedId;
    return from(this.signalService.invoke('StartSession', [orgId, objectId, objectKind, sessionId, date]));
  }

  private endSession(sessionId: string, date: string): Observable<any> {
    const orgId = this.organizationService.organizationSelectedId;
    return from(this.signalService.invoke('EndSession', [orgId, sessionId, date]));
  }

  commitSession(sessionId: string, date: string): Promise<any> {
    const orgId = this.organizationService.organizationSelectedId;
    return this.signalService.invoke('CommitTime', [orgId, sessionId, date]);
  }

  commitSessionV2(sessionId: string, committedAt: string, pauseToken: string): Promise<any> {
    const organizationId = this.organizationService.organizationSelectedId;
    const data = {
      organizationId,
      sessionId,
      committedAt,
      pauseToken
    };
    return this.signalService.invokeV2('CommitTimeV2', data);
  }

  сhangeObject(objectId: string, objectKind: ObjectKind): Observable<any> {
    const orgId = this.organizationService.organizationSelectedId;
    return from(this.signalService.invoke('ChangeObject', [orgId, this.sessionId, objectId, objectKind]));
  }

  play(objectId: string, objectKind: ObjectKind, date: string): Observable<any> {
    if (!this.isPlayValue) {
      this._activeSessionStart = date;
      this.sendToWorker('stop', date);
      this.sessionId = crypto.randomUUID()
      this._isPlay$.next(true);
      this.sendToWorker('start', date, date);
      this._error$.next(null);
      return this.startSession(objectId || this.organizationService.organizationSelectedId, objectKind || ObjectKind.Project, this.sessionId, date).pipe(
        tap({
          next: (data) => {
            if (data?.statusCode === 409) {
              this._isPlay$.next(false);
              this.sendToWorker('stop', date);
              this._duration$.next(this._timeWorkedState);
              this._error$.next('409: conflict');
            }
          },
          error: (err) => {
            this._isPlay$.next(false);
            this.sendToWorker('stop', date);
            this._duration$.next(this._timeWorkedState);
            this._error$.next(err);
          }
        }),
      );
    }// else return this.сhangeObject(objectId, objectKind);
  }

  stop(date: string): Observable<any> {
    this._isPlay$.next(false);
    this.sendToWorker('stop', date);
    return this.endSession(this.sessionId, date).pipe(
      tap({
        next: () => {
          this.sessionId = null;
          this._timeWorkedState = this._duration$.value;
        },
        error: (err) => this._error$.next(err)
      }),
      retry({ count: 1, delay: 2000 })
    );
  }

  private commit() {
    const commitDate = DateTime.now().set({ millisecond: 0 }).toUTC().toISO({ suppressMilliseconds: true });
    this.commitSession(this.sessionId, commitDate).then(() => {
      // this.lastCommit = commitDate;
    }).catch((err) => {
      this.reset(err);
    });
  }

  private tick(duration: number, durationActive: number) {
    this._durationActive$.next(durationActive);
    if (duration > 0) {
      const duarationAll = this._timeWorkedState + duration;
      this._duration$.next(duarationAll);
      if (duration % TimeTrackingSWService.DELTA === 0) {
        this.commit();
      }
    }
  }
}